
import { Component, Vue } from 'nuxt-property-decorator'

@Component({ name: 'TriangleExclamationSolid' })
export default class TriangleExclamationSolid extends Vue {}
